import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { t } from '@insight/toolkit-utils/lib/labels';
import { getPasswordStrength } from '@insight/toolkit-utils/lib/helpers/passwordStrength';

import Button from '../../../../Button/Button';
import Icon from '../../../../Icon/Icon';

const PasswordField = ({
  className,
  id,
  name,
  narrow,
  placeholder,
  value,
  errors,
  isMeter,
  ...rest
}) => {
  const classes = cn(
    'c-input c-input--password',
    {
      'c-input--narrow': narrow,
    },
    className
  );
  const strength = value ? getPasswordStrength(value) : '';

  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [isCapsLockActive, setIsCapsLockActive] = useState(false);

  const togglePasswordVisiblity = () => {
    setIsPasswordShown(!isPasswordShown);
  };

  const handleKeyUp = (e) => {
    // If "caps lock" is pressed, display the warning text
    if (e.getModifierState('CapsLock')) {
      setIsCapsLockActive(true);
    } else {
      setIsCapsLockActive(false);
    }
  };

  return (
    <>
      <input
        className={classes}
        id={id}
        name={name}
        placeholder={placeholder}
        type={isPasswordShown ? 'text' : 'password'}
        maxLength="16"
        value={value}
        onKeyUp={handleKeyUp}
        {...rest}
      />
      <Button
        className="c-password-unmask"
        color="inline-link"
        aria-label={
          isPasswordShown
            ? 'Hide password'
            : t(
                'Show password as plain text. Warning: this will display your password on the screen.'
              )
        }
        onClick={togglePasswordVisiblity}
      >
        {isPasswordShown ? t('Hide password') : t('Show password')}
      </Button>
      {isMeter && (
        <div className={`c-password-meter  is-${strength}`}>{strength}</div>
      )}
      {isCapsLockActive && (
        <small aria-live="polite" className="c-form__warning" {...rest}>
          <Icon
            icon="warning"
            type="warning"
            className="c-form__warning-icon"
          />
          {t('Caps lock is on')}
        </small>
      )}
    </>
  );
};

export default PasswordField;

PasswordField.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  isMeter: PropTypes.bool,
  name: PropTypes.string.isRequired,
  narrow: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

PasswordField.defaultProps = {
  className: '',
  isMeter: false,
  narrow: false,
  placeholder: '',
  value: '',
};
